export const isModifierGroupRequired = (
  mg: IMenuItemModifierGroupDisplay | IMenuItemModifierGroup
): boolean => {
  if (mg.min > 0) return true;
  return false;
};
